import Grid from "@material-ui/core/Grid";
import React, { useState } from "react";
import SbuSelect from '../../_shared/SbuSelect/SbuSelect';
import PropTypes from "prop-types";
import PlantSelect from "../../_shared/PlantSelect";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Accordion, AccordionDetails, AccordionSummary, Button, Typography, TextField } from "@material-ui/core";
import FactorySelect from "../../_shared/FactorySelect";
import { APP_STUDIES_LIST } from "../../../_constants";
import { utilFunctions } from "../../../_helpers";
import { useDispatch } from "react-redux";
import { ExpandMore } from "@material-ui/icons";
import FormControlWrapper from "../../_shared/FormControlWrapper";

const BestCTReportFilters = (props) => {
    const labelMinWidth = 60

    const INITIAL_STATE = {
        sbuCode: { value: '', validator: 'text', isRequired: true, error: null, disable: false },
        plantCode: { value: '', validator: 'text', isRequired: false, error: null, disable: false },
        factoryCode: { value: '', validator: 'text', isRequired: false, error: null, disable: false },
        style: { value: '', validator: 'text', isRequired: true, error: null, disable: false },
    }

    const INITIAL_FILTERED_DATA = {
        filteredPlants: [],
        filteredFactories: []
    }
    //Static studies
    const studies = APP_STUDIES_LIST

    const dispatch = useDispatch();

    const [filterState, setFilterState] = useState(INITIAL_STATE);
    const [filteredData, setFilteredData] = useState(INITIAL_FILTERED_DATA)
    const [filtersAccordion, setFiltersAccordion] = useState(true)

    // Handle sbu select dropdown change event
    const onSbuChange = (value) => {
        const sbuIndex = props.sbus.map(s => s.sbuCode).indexOf(value)
        setFilterState({
            ...filterState,
            sbuCode: {
                ...filterState.sbuCode,
                value: value
            },
            plantCode: {
                ...filterState.plantCode,
                value: ''
            },
            factoryCode: {
                ...filterState.factoryCode,
                value: ''
            }
        })

        setFilteredData({
            filteredPlants: props.sbus[sbuIndex].plants,
            filteredFactories: []
        })
    }

    // Handle plant select dropdown change event
    const onPlantChange = (value) => {
        const plantIndex = filteredData.filteredPlants.map(p => p.code).indexOf(value)
        setFilterState({
            ...filterState,
            plantCode: {
                ...filterState.plantCode,
                value: value
            },
            factoryCode: {
                ...filterState.factoryCode,
                value: ''
            },
            style: {
                ...filterState.style,
                value: ''
            }
        })

        setFilteredData({
            ...filteredData,
            filteredFactories: filteredData.filteredPlants[plantIndex].factories
        })
    }

    // Handle Factory select dropdown change event
    const onFactoryChange = (value) => {
        setFilterState({
            ...filterState,
            factoryCode: {
                ...filterState.factoryCode,
                value: value
            },
            style: {
                ...filterState.style,
                value: ''
            }
        })
    }

    // Handle module select dropdown change event
    const onStyleChange = (value) => {
        setFilterState({
            ...filterState,
            style: {
                ...filterState.style,
                value: value
            }
        })
    }

    const filterClear = () => {
        setFilterState(INITIAL_STATE)
        setFilteredData(INITIAL_FILTERED_DATA)
        // props.onFilterClear()
    }

    const filterApply = async () => {
        const [validatedData, isValid]: any = await utilFunctions.validateFormData(filterState)
        setFilterState({ ...validatedData })
        if (isValid) {
            const filters = {
                sbuCode: filterState.sbuCode.value,
                plantCode: filterState.plantCode.value,
                factoryCode: filterState.factoryCode.value,
                style: filterState.style.value,
            }
            props.onFilterApply(filters)
        }
    }
    const onDownload = async () => {
        const [validatedData, isValid]: any = await utilFunctions.validateFormData(filterState)
        setFilterState({ ...validatedData })
        if (isValid) {
            const filters = {
                sbuCode: filterState.sbuCode.value,
                plantCode: filterState.plantCode.value,
                factoryCode: filterState.factoryCode.value,
                style: filterState.style.value,
            }
            props.onDownloadClick(filters)
        }
    }

    return (
        <Accordion
            className="appAccordion"
            expanded={filtersAccordion}
            onChange={(e, expanded) => setFiltersAccordion(expanded)}
        >
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>Filters</Typography>
            </AccordionSummary>
            <AccordionDetails className="contentPadding">
                <Grid container spacing={3} className="appFilterContainer">
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="SBU" variant="inline" labelMinWidth={labelMinWidth} isRequired={filterState.sbuCode.isRequired}>
                            <SbuSelect
                                sbus={props.sbus}
                                error={!!filterState.sbuCode.error}
                                selectedValue={filterState.sbuCode.value}
                                isCodeRequiredInKey={true}
                                onSbuChange={onSbuChange} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Plant" variant="inline" labelMinWidth={labelMinWidth} isRequired={filterState.plantCode.isRequired}>
                            <PlantSelect
                                plants={filteredData.filteredPlants}
                                error={!!filterState.plantCode.error}
                                selectedValue={filterState.plantCode.value}
                                isCodeRequiredInKey={true}
                                onPlantChange={onPlantChange} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Factory" variant="inline" labelMinWidth={labelMinWidth} isRequired={filterState.factoryCode.isRequired}>
                            <FactorySelect
                                factories={filteredData.filteredFactories}
                                error={!!filterState.factoryCode.error}
                                selectedValue={filterState.factoryCode.value}
                                isCodeRequiredInKey={true}
                                onFactoryChange={onFactoryChange} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Style" variant="inline" labelMinWidth={labelMinWidth} isRequired={filterState.style.isRequired}>
                            <TextField
                                value={filterState.style.value}
                                size='small'
                                error={!!filterState.style.error}
                                variant="outlined"
                                fullWidth
                                onChange={(event) => onStyleChange(event.target.value)} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} className="appButtonGroup">
                        <Button variant="contained" onClick={filterClear}>Clear</Button>
                        <Button variant="contained" color="primary" onClick={filterApply}>
                            {props.isLoading && <CircularProgress size={20} color="inherit" />}{' '}Load
                        </Button>
                        <Button variant="contained" color="secondary" onClick={onDownload}>Download</Button>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

BestCTReportFilters.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    sbus: PropTypes.array.isRequired,
    onFilterClear: PropTypes.func.isRequired,
    onFilterApply: PropTypes.func.isRequired,
    onDownloadClick: PropTypes.func.isRequired
}

export default BestCTReportFilters;
